<breadcrumb
  [paginas]="[
    { route: '/home', name: 'Home' },
    { route: '/consulta-ponto', name: 'Registrar saída da escola' }
  ]"
/>
<section class="section-filtro">
  <app-filtro-padrao (filtroEmitter)="searchHandler($event)" [template]="2" [style]="1"></app-filtro-padrao>
</section>
<!-- TITULO -->
<section class="section-saudacao">
  <div class="container">
    <h2 class="titulo-page">Registrar saída da escola</h2>
    <app-btn-back class="btn_voltar_consulta"></app-btn-back>
  </div>
  <div class="container boas-vindas">
    <p>
      "Olá, <b>[Nome do Psicólogo]!</b> 👋
    </p>
    <p class="icon-paragraph">
      <img
        src="../../../assets/img/icons/icon-nome-escola.svg"
        title="Diretoria de Ensino"
        alt=""
      />
      <b>URE: </b> NORTE 1
    </p>
    <p class="icon-paragraph">
      <img
        src="../../../assets/img/icons/icon-nome-escola.svg"
        title="Diretoria de Ensino"
        alt=""
      />
      <b>Escola: </b> 197 - AGENOR COUTO DE MAGALHAES DOUTOR
    </p>
    <p class="icon-paragraph data-paragraph">
      <img
        src="../../../assets/img/icons/icon-calendario.svg"
        title="Diretoria de Ensino"
        alt=""
      />
      <b>00/00/0000 </b>
    </p>
  </div>
</section>


<section class="section-data-regitro-saida">
  <div class="container">
    <div class="conteudo-data-check-in-out">

      <div class="conteudo-check">
        <p>
          Hora Check in:
          <input
            type="time"
            class="input-time"
            formControlName="horarioCheckIn"
            placeholder="Hora Check-Out"
            aria-label="Hora Check-Out"
            [disabled]="true"
          />
        </p>
        <p>
          Hora Check-Out:
          <input
            type="time"
            class="input-time input-alterado"
            formControlName="horarioCheckIn"
            placeholder="Hora Check-Out"
            aria-label="Hora Check-Out"
          />
        </p>

      </div>
    </div>
        <p class="horas-trabalhadas">
          Total de horas trabalhadas:<b>02:00</b>
        </p>
  </div>
</section>


<section class="section-aprovacao-registro">
  <div class="container">
    <p><b>Tipo de entrada : </b> Ajuste em Saída: </p>

    <label class="label-textarea">Justificativa do Psicólogo: </label>
      <textarea
        class="input-textarea"
        formControlName="justificativa"
        placeholder="Digite a justificativa para o ajuste na saída"
        aria-label="Justificativa"
      ></textarea>

      <div class="conteudo-btn-aprovacao-registro">
        <button class="btn-reprovar" >
          Reprovar
        </button>
        <button class="btn-aprovar">
          Aprovar
        </button>
      </div>
  </div>
</section>


<section class="section-grid-consulta-ponto">
  <div class="container">
    <div class="row_registros">
      <h3>Registro de Entrada e Saída</h3>
      <div class="conteudo-btn-grid">
        <a
        *ngIf="this.userLogado?.codigoPerfil == 1634 || this.userLogado?.codigoPerfil == 1477"
        class="btn_adicionar_registro"
        href="javascript:void(0)"
        (click)="abrirModalInserirRegistro()">
          <i aria-hidden="true" class="fa fa-plus"></i>
        </a>
        <button class="btn_outline" >
          <!-- disabled -->
          Enviar Atividade para Validação
        </button>
      </div>
    </div>
    <div class="row_quantidade_tempo_registro">
      <p>
        <b>Total tempo de atividades registradas: 1:55</b>
      </p>
    </div>

    <div class="conteudo_legenda_grid">
      <h4>Legenda</h4>
      <div class="legenda_grid">
        <div class="legenda_item">
          <i class="fa-solid fa-circle-plus" aria-hidden="true"></i>
          <p>Adicionar Registro</p>
        </div>
        <div class="legenda_item">
          <i class="fa fa-eye" aria-hidden="true"></i>
          <p>Visualizar</p>
        </div>
        <div class="legenda_item">
          <i class="fa fa-edit" aria-hidden="true"></i>
          <p> Edição</p>
        </div>
        <div class="legenda_item">
          <i class="fa fa-trash" aria-hidden="true"></i>
          <p>Excluir</p>
        </div>
      </div>
    </div>


  </div>
</section>


